import React from 'react';
import { FormattedMessage } from 'react-intl';

function PushNotificationTutorial() {
  return (
    <div>
      <FormattedMessage id="support.basics.push-notifications" />
    </div>
  );
}

export default PushNotificationTutorial;
